import { render, staticRenderFns } from "./LazyComponent.vue?vue&type=template&id=f29578b6&"
import script from "./LazyComponent.vue?vue&type=script&lang=js&"
export * from "./LazyComponent.vue?vue&type=script&lang=js&"
import style0 from "@v4/common/components/atoms/LazyComponent/_index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports